import { SET_CURRENT_TIME, SET_SERVER_TIME_OFFSET } from '@app/actions/time';

const initialState = {
  localTime: new Date().getTime(),
  offset: 0,
};

const currentTime = (state = initialState, action) => {
  switch (action.type) {
    case SET_CURRENT_TIME:
      return {
        ...state,
        localTime: action.time,
      };
    case SET_SERVER_TIME_OFFSET:
      return {
        ...state,
        offset: action.offset,
      };
    default:
      return state;
  }
};

const getTimeOffset = state => state.time.offset;
const getCurrentTime = state => new Date().getTime() + getTimeOffset(state);

export default currentTime;
export { getTimeOffset, getCurrentTime };



// WEBPACK FOOTER //
// ./src/reducer/time.js